import {
  EventBlocks,
  EventUniqueBlocks,
  IEventBlock,
  IGuestlistBlock,
  IGuestlistBlockStatus,
  IScheduleBlock,
} from "Bands/types";
import { copy } from "shared/assets";
import { IActionDropdownItem } from "shared/components";
import { IStatus } from "shared/types";
import { mapUserPermissions } from "shared/utils";

const { actions: actionsCopy, guestlistBlock: guestlistCopy, scheduleBlock: scheduleCopy } = copy;

export const getEventBlockActions = ({
  block,
  setShowEditEventBlockTitleModal,
  setShowDeleteEventBlockModal,
  setShowDownloadGuestlistModal,
  setShowEmailGuestlistModal,
  setShowDownloadScheduleModal,
  setShowPushCopyModal,
}: {
  block: IEventBlock;
  setShowEditEventBlockTitleModal: (block: IEventBlock | null) => void;
  setShowDeleteEventBlockModal: (block: IEventBlock | null) => void;
  setShowDownloadGuestlistModal: (block: IGuestlistBlock) => void;
  setShowEmailGuestlistModal: (block: IGuestlistBlock) => void;
  setShowDownloadScheduleModal: (block: IScheduleBlock) => void;
  setShowPushCopyModal: (block: IEventBlock | null) => void;
}): IActionDropdownItem[] => {
  const { handleEditTitle, handleEdit, type, permissions } = block;
  const userPermissions = mapUserPermissions(permissions || []);

  const actions: IActionDropdownItem[] = [];

  switch (type) {
    case EventBlocks.guestlist:
      const guestlistBlock = block as IGuestlistBlock;

      actions.push({
        label:
          guestlistBlock.status === IGuestlistBlockStatus.open
            ? guestlistCopy.download.buttons.downloadAndClose
            : guestlistCopy.download.buttons.download,
        handleClick: () => setShowDownloadGuestlistModal(guestlistBlock),
        dataTestId: `${type}_block_actions_download`,
      });

      actions.push({
        label:
          guestlistBlock.status === IGuestlistBlockStatus.open
            ? guestlistCopy.email.buttons.emailAndClose
            : guestlistCopy.email.buttons.email,
        handleClick: () => setShowEmailGuestlistModal(guestlistBlock),
        dataTestId: `${type}_block_actions_email`,
      });
      break;

    case EventBlocks.schedule:
      const scheduleBlock = block as IScheduleBlock;

      actions.push({
        label: scheduleCopy.buttons.save,
        handleClick: () => setShowDownloadScheduleModal(scheduleBlock),
        dataTestId: `${type}_block_actions_download`,
      });

      break;
  }

  if (userPermissions.EDIT) {
    actions.push({
      label: actionsCopy.edit,
      handleClick: handleEdit,
      dataTestId: `${type}_block_actions_edit`,
    });
  }

  if (handleEditTitle && userPermissions.EDIT) {
    actions.push({
      label: actionsCopy.editTitle,
      handleClick: () => setShowEditEventBlockTitleModal(block),
      dataTestId: `${type}_block_actions_edit_title`,
    });
  }

  if (
    (type === EventUniqueBlocks.people || type === EventBlocks.schedule) &&
    userPermissions.EDIT
  ) {
    actions.push({
      label: "Copy to other event(s)",
      handleClick: () => setShowPushCopyModal(block),
      dataTestId: `${type}_block_actions_push_copy`,
    });
  }

  if (userPermissions.DELETE) {
    actions.push({
      label: actionsCopy.delete,
      handleClick: () => setShowDeleteEventBlockModal(block),
      dataTestId: `${type}_block_actions_delete`,
      status: IStatus.error,
    });
  }

  return actions;
};
